import { ActionContext, Module } from 'vuex';
import { IRootState } from '.';
import { EmbeddableArtifactEntryPointArgs } from '@/repositories';

// state
interface IEmbeddableStoreState {
  embeddableEntryPointArgs: EmbeddableArtifactEntryPointArgs | undefined;
}

// vuex module
class EmbeddableStore implements Module<IEmbeddableStoreState, IRootState> {
  namespaced = true;

  // state
  state: IEmbeddableStoreState = {
    embeddableEntryPointArgs: undefined
  };

  // getters
  getters = {
    embeddableEntryPointArgs(s: IEmbeddableStoreState): EmbeddableArtifactEntryPointArgs | undefined {
      return s.embeddableEntryPointArgs;
    }
  };

  // mutations
  mutations = {
    loadEmbeddableEntryPointArgs(s: IEmbeddableStoreState, value: EmbeddableArtifactEntryPointArgs): void {
      s.embeddableEntryPointArgs = value;
    }
  };

  // actions
  actions = {
    async loadEmbeddableEntryPointArgs({ rootState, commit }: ActionContext<IEmbeddableStoreState, IRootState>, id: string): Promise<void> {
      const embeddableEntryPointArgs = await rootState.container.entryPointArgsApiClient.embeddables(id);
      commit('loadEmbeddableEntryPointArgs', embeddableEntryPointArgs);
    }
  };
}

export { IEmbeddableStoreState, EmbeddableStore };

// export an instance of the store by default
export default new EmbeddableStore();
